import React from "react";
import SeoHead from "../pages/public/SeoHead";

// Marketing site (.hm-site) pages canonicalise to hellomortgage.ca — the rates app keeps hellomortgagerates.ca until cut-over.
export const MAIN_SITE_URL = "https://www.hellomortgage.ca";
const OG_DEFAULT = `${MAIN_SITE_URL}/brand/hello-mortgage-team-brx-logo.png`;

export default function SiteSeo({ ogImage = OG_DEFAULT, ...props }) {
  return <SeoHead {...props} siteUrl={MAIN_SITE_URL} ogImage={ogImage} siteName="Hello Mortgage Team" />;
}
